<template>
    <el-dialog
        :title="title"
        :visible.sync="show"
        :top="top"
        @close="$emit('input',false)"
        width="30%">
        <slot>
            <div>我是内容哈哈哈哈</div>
        </slot>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="showCancelBtn" @click="$emit('input',false)">取 消</el-button>
            <el-button type="primary" @click="sureBtnFn">{{ sureText }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        data(){
            return {
                show: false
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: '标题'
            },
            sureClose: { // 点击确定关闭弹窗
                type: Boolean,
                default: true
            },
            top: { // 顶部距离
                type: String,
                default: '200px'
            },
            sureText: { // 确认按钮文字
                type: String,
                default: '确 定'
            },
            showCancelBtn: { // 展示取消弹窗
                type: Boolean,
                default: true
            }
        },
        watch:{
            value(nval){
                this.show = nval
            }
        },
        methods: {
            sureBtnFn(){
                this.$emit('sureBtnFn')
                if(this.sureClose){
                    this.$emit('input', false)
                }
            }
        }
    }
</script>

<style lang="less" scoped>

</style>
